import { Helmet } from "react-helmet-async";

const SEO = ({
  title = "Blossom City Cleaning Services - Professional Cleaning in Kampala",
  description = "Leading cleaning services in Kampala. Post-construction cleaning, deep cleaning, fumigation, maid services & more. Trusted by 500+ clients. Call 0752 058 190",
  keywords = "cleaning services Kampala, post construction cleaning Uganda, deep cleaning services, fumigation Kampala, maid services Uganda, professional cleaners Kampala, office cleaning, home cleaning Kampala",
  image = "/images/logo.jpeg",
  url = "https://blossomcitycleaningservices.com",
  type = "website",
}) => {
  const siteName = "Blossom Cleaning Services";
  const fullTitle = title.includes(siteName) ? title : `${title} | ${siteName}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_UG" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Geo Tags */}
      <meta name="geo.region" content="UG-C" />
      <meta name="geo.placename" content="Kampala" />
      <meta name="geo.position" content="0.3476;32.5825" />
      <meta name="ICBM" content="0.3476, 32.5825" />

      {/* Canonical */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;
